export default __webpack_public_path__ + "static/media/feijoada.31c5c960.webp";